import { Draft, produce } from 'immer';
import { AnyAction, Middleware } from 'redux';

import { logger } from '@app/libs/logger';
import ContractProgressTextFieldInformation from '@app/store/contract-progress/TextFieldInformation';
import EditingDocumentTextFieldInformation from '@app/store/editingDocument/TextFieldInformation';
import FieldType from '@app/store/FieldType';
import { RootState } from '@app/store/types';

const createLoggerMiddleWare: (stateSanitizer: (state: RootState) => RootState) => Middleware =
  () => () => (next) => (action: AnyAction) => {
    if ('error' in action && action.error) {
      logger.error('redux failure action dispatched', {
        action: { type: action.type, errorMessage: action.payload?.message },
      });
    }

    return next(action);
  };

const stateSanitizer = produce((draft: Draft<RootState>) => {
  const replacement = '********';
  const replace = <T>(value: T): T | string => (value ? replacement : value);

  /**
   * 서명 진행전 인증 단계에서 인증키와 링크키 마스킹
   */
  draft.contractAuthentication.authenticationKey = replace(
    draft.contractAuthentication.authenticationKey
  );

  /**
   * 서명 진행 단계에서 인증키와 텍스트 필드 입력값 마스킹
   */
  draft.contractProgress.authenticationKey = replace(draft.contractProgress.authenticationKey);
  Object.values(draft.contractProgress.field.information)
    .filter(
      (field): field is ContractProgressTextFieldInformation => field.type === FieldType.TEXT_FIELD
    )
    .forEach((field) => {
      field.value = replace(field.value);
    });

  /**
   * 요청자 필드에 입력된 텍스트 필드 입력값 마스킹
   */
  draft.documentSetup.requesterTextFields
    .map((requesterTextField) => requesterTextField.values)
    .forEach((reqesterTextFieldValue) => {
      reqesterTextFieldValue.text = replace(reqesterTextFieldValue.text);
    });

  /**
   * 문서 편집의 텍스트 필드에 입력값 마스킹
   */
  Object.values(draft.editingDocument.information)
    .filter(
      (field): field is EditingDocumentTextFieldInformation => field.type === FieldType.TEXT_FIELD
    )
    .forEach((field) => {
      field.value = replace(field.value);
    });
});

export default createLoggerMiddleWare(stateSanitizer);
